import axios from "axios";
import { useTranslation } from "react-i18next";
import { useRefresh } from "../../../../utils/RefreshProvider";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import Notify from "../../../../utils/useNotify";
import { ArrowPathIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import ColorPicker from "./ColorPicker";

export default function EditColor({ colorId }) {
  const { t } = useTranslation();
  const { triggerRefresh } = useRefresh();
  const token = localStorage.getItem('token');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [isOpen, setIsOpen] = useState(false);
  const [nameEn, setNameEn] = useState('');
  const [nameFr, setNameFr] = useState('');
  const [hexCode, setHexCode] = useState('');
  const [loading, setLoading] = useState(false);

  function closeModal() { setIsOpen(false) }

  const openModal = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${localhost}color/${colorId}`);
      const data = res.data;
      if (data) {
        setNameEn(data.name.en);
        setNameFr(data.name.fr);
        setHexCode(data.hex);
      }
      setIsOpen(true);
    } catch (err) {
      // 
    } finally {
      setLoading(false);
    };
  };

  const handleUpdate = (e) => {
    const colorData = { name: { en: nameEn, fr: nameFr }, hex: hexCode };

    axios.put(`${localhost}admin/colors/${colorId}`, colorData, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        Notify('success', t('edit-color-success'));
        triggerRefresh();
        setIsOpen(false);
        setNameEn('');
        setNameFr('');
        setHexCode('');
      })
      .catch((err) => {
        Notify('error', t('edit-color-error'));
        console.error(err);
      });
  };

  return (
    <>
      {/* ${loading ? 'bg-black/60 cursor-not-allowed' : 'bg-black hover:bg-black/80'} */}
      <button onClick={openModal} className="text-black transition-colors duration-150 hover:bg-black/10 rounded-md p-1.5">
        {
          loading ? (
            <span className="flex justify-center items-center">
              <ArrowPathIcon className="animate-spin text-black size-5"/>
            </span>
          ) : (<>
            <PencilSquareIcon className="size-5" />
          </>)
        }
      </button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div>
                    <div className='grid grid-cols-2 gap-2 mb-3'>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-1 text-sm font-medium text-black">Name <span className="text-orange-500 text-xs">({t("english")})</span></label>
                        <input type="text" value={nameEn} onChange={(e) => setNameEn(e.target.value)}
                          className="focus:ring-orange-600 focus:border-orange-600 placeholder:lowercase bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5" placeholder="Name" required />
                      </div>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-1 text-sm font-medium text-black">Titre <span className='text-orange-500 text-xs'>({t("french")})</span></label>
                        <input type="text" value={nameFr} onChange={(e) => setNameFr(e.target.value)}
                          className="focus:ring-orange-600 focus:border-orange-600 placeholder:lowercase bg-gray-50 border text-black text-sm rounded-lg block w-full p-2.5" placeholder="Titre" required />
                      </div>
                    </div>

                    <div className='grid grid-cols-2 gap-2 mb-2'>
                    <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-1 text-sm font-medium text-black">Color</label>
                        <ColorPicker value={hexCode} onChange={setHexCode} />
                      </div>
                    </div>

                    <div className="w-full flex justify-end items-center gap-2">
                      <button onClick={handleUpdate} className='py-2 px-4 bg-black hover:bg-black/80 text-white rounded-md text-sm'>{t("edit")}</button>
                      <button type="button" className='border py-2 px-4 bg-white hover:bg-gray-100 hover:text-black/80 text-black rounded-md text-sm' onClick={() => setIsOpen(false)}>{t("cancel")}</button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
